import React, { useCallback, useEffect, useMemo, useState } from "react";
import ADSButton from "../../Routes/Home/Components/ADS/Component/ADSButton";
import AutoFixHighIcon from "@mui/icons-material/AutoFixHigh";
import LoadingIcon from "../../Assets/Icons/circular-determinate.svg";
import "./PromptWizard.scss";
import axiosInstance from "../../axiosInstance";
import PromptWizardTabs from "./PromptWizardTabs";

const WizardTab = {
  Original: 1,
  ReWrite: 0,
};

const PromptWizard = ({
  prompt,
  originalPrompt,
  onSelectWizardPrompt,
  disabled,
  square = false,
  style,
  fullWidth = false,
  outline = false,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [activeTab, setActiveTab] = useState(WizardTab.ReWrite);
  const [wizardPrompt, setWizardPrompt] = useState("");

  const [reWrittenPrompt, setRewrittenPrompt] = useState({
    prompt: "",
    oldPrompt: "",
  });
  const [isLoadingRewrittenPrompt, setIsLoadingRewrittenPrompt] =
    useState(false);

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setActiveTab(WizardTab.ReWrite);
    setIsLoadingRewrittenPrompt(false);
  };

  const handleChangeActiveTab = (selectedTab) => {
    setActiveTab(selectedTab);
  };

  const getReWrittenPrompt = useCallback(() => {
    if (!originalPrompt) {
      console.log("No prompt to rewrite");
      setIsLoadingRewrittenPrompt(false);
      return setRewrittenPrompt({
        prompt: "",
        oldPrompt: "",
      });
    }

    setIsLoadingRewrittenPrompt(true);
    let formData = new FormData();
    formData.append("prompt", originalPrompt);
    formData.append("promptType", "prompt");
    formData.append("editType", "REWRITE");

    const fullUrl =
      window.localStorage.getItem("BaseURL") +
      "/services/projectmanagement/api/products/magic-prompt";

    axiosInstance
      .post(fullUrl, formData)
      .then((res) => {
        setRewrittenPrompt({
          prompt: res.data.prompt,
          oldPrompt: originalPrompt,
        });
      })
      .catch((err) => {
        console.log("Error getting reWrittenPrompt", err);
      })
      .finally(() => setIsLoadingRewrittenPrompt(false));
  }, [originalPrompt]);

  const showLoading = useMemo(() => {
    if (activeTab === WizardTab.ReWrite) {
      return isLoadingRewrittenPrompt;
    } else {
      return false;
    }
  }, [activeTab, isLoadingRewrittenPrompt]);

  useEffect(() => {
    if (isModalOpen) {
      switch (activeTab) {
        case WizardTab.ReWrite: {
          if (
            reWrittenPrompt.prompt &&
            reWrittenPrompt.oldPrompt &&
            reWrittenPrompt.oldPrompt === originalPrompt
          ) {
            setWizardPrompt(reWrittenPrompt.prompt);
          } else if (originalPrompt) {
            getReWrittenPrompt();
          }
          break;
        }

        case WizardTab.Original:
        default:
          setWizardPrompt(originalPrompt);
      }
    }
  }, [
    activeTab,
    originalPrompt,
    reWrittenPrompt,
    getReWrittenPrompt,
    isModalOpen,
  ]);

  const isDisabled = disabled || !originalPrompt;

  return (
    <div className="ads-prompt-wizard" style={style}>
      <ADSButton
        onClick={() => setIsModalOpen(true)}
        disabled={isDisabled}
        className={`${square ? "ads-prompt-wizard--square" : ""} ${
          outline && !isDisabled ? "ads-prompt-wizard--outline" : ""
        }`}
        style={{ height: 48, width: fullWidth ? "100%" : 192 }}
      >
        <AutoFixHighIcon style={{ width: 20, height: 20 }} />
        Prompt Wizard
      </ADSButton>

      {isModalOpen && (
        <>
          <div className="outline" onClick={handleCloseModal}></div>

          <div className="modal open">
            <span className="close-btn" onClick={handleCloseModal}>
              ×
            </span>
            <div className="tabs-container">
              <PromptWizardTabs
                tabs={["AI Compatible", "Your Prompt"]}
                activeTab={activeTab}
                setActiveTab={handleChangeActiveTab}
                tabWidth={150}
              />
            </div>

            <div className="tab-content">
              {Object.values(WizardTab).map((tab) => (
                <div
                  className={`tab-panel ${activeTab === tab ? "active" : ""}`}
                  key={tab}
                >
                  {showLoading ? (
                    <img className="loading" alt="" src={LoadingIcon} />
                  ) : (
                    <p>{wizardPrompt}</p>
                  )}
                </div>
              ))}
              <div className="modal-footer">
                <button
                  className="cta-btn"
                  onClick={() => {
                    onSelectWizardPrompt(wizardPrompt);
                    handleCloseModal();
                  }}
                >
                  Use this Prompt
                </button>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default PromptWizard;
